export function logEventAnalyticsUtil () {}
